
import React from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Check, X, GraduationCap, Sparkles } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const PricingTable: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div id="pricing-section" className="mt-10 animate-fade-in">
      <div className="glass-card rounded-xl p-6 shadow-soft border border-primary/20 bg-background/95 backdrop-blur-md">
        <h3 className="text-xl font-bold text-center text-primary mb-2">Enhance Your Career Journey</h3>
        <p className="text-center text-muted-foreground mb-6">
          Choose the right plan to get personalized guidance from our AI Career Agents
        </p>
        
        <div className="bg-accent/10 p-4 rounded-lg mb-6 text-center">
          <p className="text-sm font-medium flex items-center justify-center gap-2">
            <Sparkles className="h-4 w-4 text-accent animate-pulse" />
            <span className="text-accent font-semibold">Limited time offer: Professional-level AI Agents available for FREE!</span>
            <Sparkles className="h-4 w-4 text-accent animate-pulse" />
          </p>
        </div>
        
        <div className="overflow-x-auto">
          <Table className="border rounded-lg overflow-hidden">
            <TableHeader>
              <TableRow className="bg-muted/50">
                <TableHead className="font-medium">Features</TableHead>
                <TableHead className="text-center font-medium">Free</TableHead>
                <TableHead className="text-center font-medium bg-primary/5">
                  Professional
                  <div className="bg-primary/20 text-primary text-xs px-2 py-0.5 rounded-full mt-1 inline-block">Current Offer</div>
                </TableHead>
                <TableHead className="text-center font-medium">
                  PhD Level
                  <div className="bg-secondary/20 text-secondary text-xs px-2 py-0.5 rounded-full mt-1 inline-block">Coming Soon</div>
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell className="font-medium">Monthly Price</TableCell>
                <TableCell className="text-center">$0</TableCell>
                <TableCell className="text-center bg-primary/5">
                  <span className="line-through text-muted-foreground">$9</span>
                  <span className="ml-2 font-bold text-primary">$0</span>
                </TableCell>
                <TableCell className="text-center">$19</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">AI Agent Level</TableCell>
                <TableCell className="text-center">Professional-level AI Agents</TableCell>
                <TableCell className="text-center bg-primary/5">Professional-level AI Agents</TableCell>
                <TableCell className="text-center">PhD-level Expert AI Agents</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">AI Career Agent Chat</TableCell>
                <TableCell className="text-center">2 questions limit</TableCell>
                <TableCell className="text-center bg-primary/5">Unlimited</TableCell>
                <TableCell className="text-center">Unlimited</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">Resume Analysis</TableCell>
                <TableCell className="text-center"><X className="mx-auto text-muted-foreground" /></TableCell>
                <TableCell className="text-center bg-primary/5"><Check className="mx-auto text-primary" /></TableCell>
                <TableCell className="text-center"><Check className="mx-auto text-primary" /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">LinkedIn Profile Review</TableCell>
                <TableCell className="text-center"><X className="mx-auto text-muted-foreground" /></TableCell>
                <TableCell className="text-center bg-primary/5"><Check className="mx-auto text-primary" /></TableCell>
                <TableCell className="text-center"><Check className="mx-auto text-primary" /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">Expert Industry Knowledge</TableCell>
                <TableCell className="text-center"><X className="mx-auto text-muted-foreground" /></TableCell>
                <TableCell className="text-center bg-primary/5"><Check className="mx-auto text-primary" /></TableCell>
                <TableCell className="text-center"><Check className="mx-auto text-primary" /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">Advanced Career Strategies</TableCell>
                <TableCell className="text-center"><X className="mx-auto text-muted-foreground" /></TableCell>
                <TableCell className="text-center bg-primary/5"><X className="mx-auto text-muted-foreground" /></TableCell>
                <TableCell className="text-center"><Check className="mx-auto text-primary" /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">Research-Backed Guidance</TableCell>
                <TableCell className="text-center"><X className="mx-auto text-muted-foreground" /></TableCell>
                <TableCell className="text-center bg-primary/5"><X className="mx-auto text-muted-foreground" /></TableCell>
                <TableCell className="text-center"><Check className="mx-auto text-primary" /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell className="text-center">
                  <Button variant="outline" size="sm" onClick={() => !isAuthenticated && document.dispatchEvent(new CustomEvent('open-auth'))} asChild={isAuthenticated}>
                    {isAuthenticated ? <a href="/chat">Start Now</a> : <span>Start Now</span>}
                  </Button>
                </TableCell>
                <TableCell className="text-center bg-primary/5">
                  <Button size="sm" className="bg-primary" onClick={() => !isAuthenticated && document.dispatchEvent(new CustomEvent('open-auth'))} asChild={isAuthenticated}>
                    {isAuthenticated ? <a href="/chat">Get Started</a> : <span>Get Started</span>}
                  </Button>
                </TableCell>
                <TableCell className="text-center">
                  <Button variant="outline" size="sm" disabled>
                    <GraduationCap className="mr-1 h-4 w-4" />
                    Coming Soon
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default PricingTable;
